<div class="container text-start mt-3">
  <!-- Form -->
  <div class="text-center mb-3">
    <h4>
      {{'group-creation.form_create_group' | translate}}
      <button [attr.id]="'btnToggleDescription'" (click)="helper.toggleSubject(showDescriptionSubject)" aria-label="Information" mat-button>
        <fa-icon [icon]="faInfoCircle"></fa-icon>
      </button>
    </h4>
    <div *ngIf="showDescription$ | async" class="row justify-content-center">
      <div class="col-sm-9">
        <p class="text-justify">{{ 'group-creation.form_create_group_information' | translate }}</p>
      </div>
    </div>
  </div>

  <!-- Title and description -->
  <div class="form-group">
    <strong>{{'group-creation.form_create_group_name_grouptype_description' | translate}}</strong>
  </div>

  <form [formGroup]="groupFormType">
    <div class="row form-container">
      <div class="col-12 col-sm-6">
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>{{'group-creation.form_create_group_name' | translate}}</mat-label>
          <input [attr.id]="'name'" formControlName="name" matInput type="text" />
          <div *ngIf="submitted && f.name.invalid">
            <mat-error *ngIf="f.name.errors?.required">{{'group-creation.error_is_required' | translate}}</mat-error>
            <mat-error *ngIf="f.name.errors?.maxlength">{{'group-creation.error_max_255_characters' | translate}}</mat-error>
          </div>
        </mat-form-field>
      </div>
      <div class="col-12 col-sm-6">
        <mat-form-field appearance="outline">
          <mat-label>{{'group-creation.form_create_group_grouptype' | translate}}</mat-label>
          <mat-select [attr.id]="'selectGroupType'" formControlName="grouptype" required>
            <mat-option [attr.id]="'option_' + type" *ngFor="let type of groupType" [value]="type"
              >{{('group-creation.' + type.toLowerCase()) | translate}}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <hr />

    <div *ngIf="f.grouptype.value === 'STUDY'">
      <div *ngIf="(globalRole$ | async) === 'admin'">
        <div class="mb-3">
          <div class="form-group">
            <div *ngIf="f.grouptype.value === 'STUDY'; then thenShowStudy else elseShowGroup"></div>
            <ng-template #thenShowStudy>
              <strong>{{'group-creation.form_create_study_owner_description' | translate}}</strong>
            </ng-template>
            <ng-template #elseShowGroup>
              <strong>{{'group-creation.form_create_organisation_owner_description' | translate}}</strong>
            </ng-template>
          </div>
          <div class="form-group row">
            <div class="col-sm-8">
              <mat-form-field appearance="outline">
                <mat-label>{{'group-creation.form_select_owner' | translate}}</mat-label>
                <mat-select
                  [attr.id]="'selectOwnerId'"
                  (click)="resetFilter()"
                  (selectionChange)="updateOrganisationSelection($event)"
                  formControlName="owner_id"
                  required
                >
                  <mat-form-field class="full-width" appearance="fill">
                    <mat-label>{{'group-creation.filter_selection' | translate}}</mat-label>
                    <input
                      [attr.id]="'userSelection'"
                      autocomplete="off"
                      matInput
                      (keyup)="onKeyFilter()"
                      [(ngModel)]="filter['userSelection']"
                      [ngModelOptions]="{standalone: true}"
                    />
                  </mat-form-field>
                  <mat-option [attr.id]="'option_' + owner.id" *ngFor="let owner of (allECoachesAsAdmin$ | async)" [value]="owner.id"
                    >{{owner?.attributes.email | translate}}</mat-option
                  >
                  <mat-option [attr.id]="'option_none'" *ngIf="(allECoachesAsAdmin$ | async).length < 1"
                    >{{'group-creation.no_ecoach_available' | translate}}</mat-option
                  >
                </mat-select>
                <mat-error *ngIf="submitted && (f.owner_id.value < 0)">{{'group-creation.error_selection_needed' | translate}}</mat-error>
              </mat-form-field>

              <div class="form-group">
                <strong>{{'group-creation.select_organisation_description' | translate}}</strong>
              </div>
              <div class="form-group row">
                <div class="col-sm-8">
                  <mat-form-field appearance="outline">
                    <mat-label>{{'group-creation.select_organisation_label' | translate}}</mat-label>
                    <mat-select [attr.id]="'selectOrganisation'" (click)="resetFilter()" [(value)]="selectedOrganisation">
                      <mat-form-field class="full-width" appearance="fill">
                        <mat-label>{{'group-creation.filter_selection_organisation' | translate}}</mat-label>
                        <input
                          [attr.id]="'organisationSelection'"
                          autocomplete="off"
                          matInput
                          (keyup)="onKeyFilterOrganisation()"
                          [(ngModel)]="filter['organisationSelection']"
                          [ngModelOptions]="{standalone: true}"
                        />
                      </mat-form-field>
                      <mat-option [attr.id]="'option_' + org.id" *ngFor="let org of (organisations$ | async)" [value]="org"
                        >{{org?.attributes.name | translate}}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <hr />
        </div>
      </div>
    </div>

    <div *ngIf="f.grouptype.value === 'ORGANISATION'">
      <div class="form-group">
        <strong>{{'group-creation.form_create_organisation_owner_description' | translate}}</strong>
      </div>
      <div class="form-group row">
        <div class="col-sm-8">
          <mat-form-field appearance="outline">
            <mat-label>{{'group-creation.form_create_group_owner' | translate}}</mat-label>
            <mat-select
              [attr.id]="'selectOwnerId'"
              (click)="resetFilter()"
              (selectionChange)="updateOrganisationSelection($event)"
              formControlName="owner_id"
              required
            >
              <mat-form-field class="full-width" appearance="fill">
                <mat-label>{{'group-creation.filter_selection' | translate}}</mat-label>
                <input
                  [attr.id]="'userSelection'"
                  autocomplete="off"
                  matInput
                  (keyup)="onKeyFilter()"
                  [(ngModel)]="filter['userSelection']"
                  [ngModelOptions]="{standalone: true}"
                />
              </mat-form-field>
              <mat-option [attr.id]="'option_' + owner.id" *ngFor="let owner of (allECoachesAsAdmin$ | async)" [value]="owner.id"
                >{{owner?.attributes.email | translate}}</mat-option
              >
              <mat-option [attr.id]="'option_none'" *ngIf="(allECoachesAsAdmin$ | async).length < 1"
                >{{'group-creation.no_ecoach_available' | translate}}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="submitted && (f.owner_id.value < 0)">{{'group-creation.error_selection_needed' | translate}}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <!-- Set group picture -->
    <div
      *ngIf="((f.grouptype.value === 'STUDY') &&
     (((isECoach$ | async) && ((globalRole$ | async) === 'ecoach')) || ((isECoach$ | async) && ((globalRole$ | async) === 'admin') && isOwnerAndECoach())))"
    >
      <!-- Privacy settings for groups -->
      <div class="mb-3">
        <div class="form-group">
          <strong>{{'group-creation.form_create_group_privacy_description' | translate}}</strong>
        </div>
        <mat-radio-group
          [attr.id]="'radioIsPrivate'"
          (change)="showIsPrivate($event)"
          aria-label="select an option"
          formControlName="is_private"
        >
          <mat-radio-button id="radioItem0" value="0">{{'group-creation.no' | translate}}</mat-radio-button>
          <mat-radio-button id="radioItem1" value="1">{{'group-creation.yes' | translate}}</mat-radio-button>
        </mat-radio-group>

        <div *ngIf="(selectedIsPrivate$ | async) === '1'" class="form-container">
          <mat-form-field appearance="outline">
            <mat-label>{{'group-creation.form_create_group_access_type' | translate}}</mat-label>
            <mat-select
              [attr.id]="'selectIsPrivate'"
              (selectionChange)="showAccesstype(groupFormType.value.accesstype)"
              formControlName="accesstype"
              required
            >
              <mat-option [attr.id]="'option_' + type" *ngFor="let type of accessType" [value]="type"
                >{{('group-creation.' + type.toLowerCase()) | translate}}</mat-option
              >
            </mat-select>
          </mat-form-field>

          <mat-form-field *ngIf="((selectedAccesstype$ | async) === 'PASSWORD')" appearance="outline" class="full-width">
            <mat-label>{{'group-creation.password' | translate}}</mat-label>
            <input [attr.id]="'password'" formControlName="password" matInput type="text" />
            <div *ngIf="submitted && f.password.invalid">
              <mat-error *ngIf="f.password.errors?.required || f.password.errors?.minLength"
                >{{'group-creation.error_is_required' | translate}}</mat-error
              >
              <mat-error *ngIf="f.password.errors?.maxlength">{{'group-creation.error_max_255_characters' | translate}}</mat-error>
            </div>
          </mat-form-field>
        </div>

        <hr />
      </div>

      <div class="form-group">
        <strong>{{'group-creation.form_create_set_group_picture' | translate}}</strong>
      </div>

      <div class="form-group row justify-content-center">
        <div class="image-preview mb-3">
          <img [src]="displayImagePreview()" (error)="helper.getFallbackImage($event)" />
        </div>
        <div *ngIf="fileUploadProgress" class="progress form-group">
          <div [style.width.%]="fileUploadProgress" class="progress-bar progress-bar-striped bg-success" role="progressbar"></div>
        </div>
      </div>

      <!-- Upload group picture -->
      <div class="mt-2 mb-2 ml-2 mr-2">
        <div class="row">
          <div class="custom-file form-group col-12 col-sm-8 mb-2">
            <input
              #fileInputPicture
              [attr.id]="'image'"
              (change)="processFile($event)"
              accept="image/png, image/jpeg, image/jpg, image/gif, image/svg+xml"
              class="custom-file-input"
              id="customFileStudyMedia"
              name="image"
              type="file"
            />
            <label
              [attr.data-browse]="('group-creation.browse' | translate)"
              class="custom-file-label text-start"
              for="customFileStudyMedia"
              >{{uploadedFilePath}}</label
            >
          </div>
          <div class="form-group col-12 col-sm-4 mb-2">
            <button [attr.id]="'btnClearImage'" (click)="clearImage()" class="spacing-right" mat-button>
              {{'group-creation.clear' | translate}}
            </button>
          </div>
        </div>
      </div>

      <hr />
    </div>

    <!-- Title and description -->
    <div
      *ngIf="((f.grouptype.value === 'STUDY') &&
     (((isECoach$ | async) && ((globalRole$ | async) === 'ecoach')) || ((isECoach$ | async) && ((globalRole$ | async) === 'admin') && isOwnerAndECoach())))"
    >
      <div class="form-group">
        <strong>{{'group-creation.form_create_group_translations_description' | translate}}</strong>
      </div>
      <div class="row">
        <!-- Filter button -->
        <div class="col-sm-6">
          <div>
            <mat-form-field appearance="outline" class="text-width">
              <mat-label>{{'group-creation.form_create_group_title_german' | translate}}</mat-label>
              <input [attr.id]="'deTitle'" formControlName="deTitle" matInput type="text" />
              <div *ngIf="submitted && f.deTitle.invalid">
                <mat-error *ngIf="f.deTitle.errors?.required">{{'group-creation.error_is_required' | translate}}</mat-error>
                <mat-error *ngIf="f.deTitle.errors?.maxlength">{{'group-creation.error_max_255_characters' | translate}}</mat-error>
              </div>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field appearance="outline" class="text-width">
              <mat-label>{{'group-creation.form_create_group_description_german' | translate}}</mat-label>
              <textarea [attr.id]="'deDescription'" formControlName="deDescription" matInput maxlength="255" rows="3"></textarea>
              <div *ngIf="submitted && f.deDescription.invalid">
                <mat-error *ngIf="f.deDescription.errors?.required">{{'group-creation.error_is_required' | translate}}</mat-error>
                <mat-error *ngIf="f.deDescription.errors?.maxlength">{{'group-creation.error_max_255_characters' | translate}}</mat-error>
              </div>
            </mat-form-field>
          </div>
        </div>

        <div class="col-sm-6">
          <div>
            <mat-form-field appearance="outline" class="text-width">
              <mat-label>{{'group-creation.form_create_group_title_english' | translate}}</mat-label>
              <input [attr.id]="'enTitle'" formControlName="enTitle" matInput type="text" />
              <div *ngIf="submitted && f.enTitle.invalid">
                <mat-error *ngIf="f.enTitle.errors?.required">{{'group-creation.error_is_required' | translate}}</mat-error>
                <mat-error *ngIf="f.enTitle.errors?.maxlength">{{'group-creation.error_max_255_characters' | translate}}</mat-error>
              </div>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field appearance="outline" class="text-width">
              <mat-label>{{'group-creation.form_create_group_description_english' | translate}}</mat-label>
              <textarea [attr.id]="'deDescription'" formControlName="enDescription" matInput maxlength="255" rows="3"></textarea>
              <div *ngIf="submitted && f.enDescription.invalid">
                <mat-error *ngIf="f.enDescription.errors?.required">{{'group-creation.error_is_required' | translate}}</mat-error>
                <mat-error *ngIf="f.enDescription.errors?.maxlength">{{'group-creation.error_max_255_characters' | translate}}</mat-error>
              </div>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <div [ngSwitch]="f.grouptype.value" class="row text-end mb-1 justify-content-end">
      <div class="col align-self-end">
        <button [attr.id]="'btnCreateGroup'" (click)="createGroup()" *ngSwitchCase="'STUDY'" [disabled]="disabled" mat-button type="submit">
          {{'group-creation.form_create_study_submit' | translate}}
        </button>
        <button
          [attr.id]="'btnCreateOrganisation'"
          (click)="createOrganisation()"
          *ngSwitchCase="'ORGANISATION'"
          [disabled]="disabled"
          mat-button
          type="submit"
        >
          {{'group-creation.form_create_organisation_submit' | translate}}
        </button>
        <button []="'btnCreateGroup'" *ngSwitchDefault [disabled]="disabled" mat-button type="submit">
          {{'group-creation.form_create_group_submit' | translate}}
        </button>
      </div>
    </div>
  </form>
</div>
